module.exports = __webpack_public_path__ + "img/aplicaciones-foto2.19d64fc8.png";